export const reverseDate = (date) => {
  return date.split('-').reverse().join('-');
}

export const images = {
  accessories: 'akcesoria.png',
  battery: 'akumulatory.png',
  filters: 'filtry.png',
  videoRepair: 'wideonaprawa.png',
  wipers: 'wycieraczki.png',
  springPremiumPackages: 'wiosennepakietypremium.png',
  airClean: 'czyszczenie_klimatyzacji.png',
  tires: 'opony.png',
  serviceContracts: 'umowyserwisowe.jpg',
  brakePads: 'brakepads.png',
  brakeDiscs: 'brakediscs.png'
}

export const pdfs = {
  accessories: '/pdf/regulamin_programu_motywacyjnego_akcesoria_w_serwisie_2026_kc.pdf',
  battery: '/pdf/regulamin_konkurs_akumulatory_2025.pdf',
  filters: '/pdf/regulamin_programu_motywacyjnego_filtry_antyalergiczne_2026.pdf',
  videoRepair: '/pdf/regulamin_programu_motywacyjnego_wideonaprawa_2026_wer_kd_od_01_09.pdf',
  wipers: '/pdf/regulamin_programu_motywacyjnego_wycieraczki_oryginalne_2026.pdf',
  springPremiumPackages: '/pdf/regulamin_konkurs_pakiety_premium_2025.pdf',
  airClean: '/pdf/regulamin_programu_motywacyjnego_czyszczenie_klimatyzacji_2026_rpwe.pdf',
  tires: '/pdf/regulamin_konkurs_opony.pdf',
  serviceContracts: '/pdf/regulamin_programu_motywacyjnego_umowy_serwisowe_warsztat_2026.pdf',
  serviceContractsManual: '/pdf/manual_dla_bok_su_serwis_062026_1.pdf',
  brakePads: '/pdf/regulamin_programu_motywacyjnego_klocki_hamulcowe_oryginalne_2026.pdf',
  brakeDiscs: '/pdf/regulamin_programu_motywacyjnego_tarcze_hamulcowe_oryginalne_2026.pdf'
}